import type { ScreenplayEditorBlock } from './screenplayEditor';
import type { SentenceAudioBlock } from './audioBlockMap';

// A deterministic, viewport-independent estimate, NOT imported PDF pagination
// or a billing entitlement. Keep each paragraph intact at the range boundary.
const LINES_PER_PAGE = 55;
function wrappedLines(text: string, width: number): number {
  return text.split(/\r?\n/).reduce((sum, line) => {
    let used = 0, lines = 1;
    for (const word of line.trim().split(/\s+/).filter(Boolean)) {
      if (used && used + 1 + word.length > width) { lines++; used = 0; }
      const length = used + (used ? 1 : 0) + word.length;
      lines += Math.floor(Math.max(0, length - 1) / width);
      used = ((length - 1) % width) + 1;
    }
    return sum + lines;
  }, 0);
}
export function estimatedScreenplayPages(blocks: ScreenplayEditorBlock[]) {
  let lines = 0;
  const starts = new Map<string, number>();
  for (const block of blocks) {
    const page = Math.floor(lines / LINES_PER_PAGE) + 1;
    starts.set(block.id, page);
    if (block.parentheticalId) starts.set(block.parentheticalId, page);
    const dialogue = block.type === 'dialogue';
    lines += wrappedLines(block.text, dialogue ? 35 : 60) + 1
      + (dialogue ? 1 : 0) + (block.parenthetical ? wrappedLines(block.parenthetical, 30) : 0);
  }
  return { total: Math.max(1, Math.ceil(lines / LINES_PER_PAGE)), starts };
}
export function withinConversionPages(sentences: SentenceAudioBlock[], blocks: ScreenplayEditorBlock[], pageLimit?: number) {
  if (pageLimit === undefined) return sentences;
  const { starts } = estimatedScreenplayPages(blocks);
  return sentences.filter(sentence => (starts.get(sentence.sourceBlockId) ?? Infinity) <= pageLimit);
}
export function blockWithinConversionPages(blockId: string, blocks: ScreenplayEditorBlock[], pageLimit?: number) {
  return pageLimit === undefined || (estimatedScreenplayPages(blocks).starts.get(blockId) ?? Infinity) <= pageLimit;
}
